<form *ngIf="form" [formGroup]="form" fxLayout="row wrap" fxLayoutGap="16px">
    <ng-container *ngFor="let field of pricingFields; let i = index">
        <div class="field-with-previous-step-hint" [fxFlex]="getFxFlex(i)" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
            [class.field--modified]="isPropertyModified(field.key)">
            <mat-label>{{ field.label }}</mat-label>
            <input *ngIf="field.type !== 'textarea'" matInput [type]="field.type || 'text'" [readonly]="!canEdit"
                [formControlName]="field.key" />
            <textarea *ngIf="field.type === 'textarea'" matInput [readonly]="!canEdit" [formControlName]="field.key">
      </textarea>
            <mat-error *ngIf="form.get(field.key)?.invalid">
                <ng-container *ngIf="form.get(field.key)?.errors as errors">
                    <span *ngIf="errors['max']">
                        Maximum number can be {{ errors['max'].max }}.
                    </span>
                    <span *ngIf="errors['min']">
                        Minimum required number can be {{ errors['min'].min }}.
                    </span>
                    <span *ngIf="errors['maxlength']">
                        Maximum length can be {{ errors['maxlength'].requiredLength }} characters.
                    </span>
                    <span *ngIf="errors['pattern']">
                        {{ field.patternHint || 'Invalid format.' }}
                    </span>
                </ng-container>
            </mat-error>
        </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue(field.key) as text">{{ text }}</div>
                                </div>
    </ng-container>
</form>